export default {
  EDITOR_APP_ID: 'editorAppId',
} as const;
